import { render, staticRenderFns } from "./transmission.vue?vue&type=template&id=595e2163&"
import script from "./transmission.vue?vue&type=script&lang=js&"
export * from "./transmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports